import { render, staticRenderFns } from "./AccountContactMapping.vue?vue&type=template&id=08844608&"
import script from "./AccountContactMapping.vue?vue&type=script&lang=js&"
export * from "./AccountContactMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports